import React from 'react';
import {I18n} from 'react-redux-i18n';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {size, get} from 'lodash';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import MainFilter from './components/MainFilter';
import Select from '../../components/Select';
import MultipleSelectFilter from '../../LibraryFilter/component/MultipleSelectFilter';
import {
  setCardView,
  setGroups,
  loadGroups,
  loadHealthStatus,
  setHealthStatus,
  clearFilterMobile
} from './HealthFiltersActions';
import {getReportURL} from '../DVRhealthActions';
// import DownloadHealthReport from '../component/DownloadHealthReport';

const styleSheet = () => ({
  flex: {
    flex: 1
  }
});

class HealthMobileFilterBar extends React.Component {
  constructor(props) {
    super(props);
    const {applied} = props;
    const {groups, status, cardView} = applied;
    this.state = {
      groups,
      status,
      cardView,
      open: false
    };
  }

  componentDidMount() {
    this.props.loadGroups();
    this.props.loadHealthStatus();
  }

  handleOpen = () => {
    this.setState({open: true});
  }

  handleHealthStatusSelection = value => {
    this.setState({status: value});
  }

  handleRequestClose = () => {
    this.setState({open: false});
  }

  filterCount = () => {
    const {groups, chips} = this.props.applied;
    return size([...groups, ...chips]);
  }

  handleOnClear = () => {
    this.setState({groups: [], status: [], cardView: 'standard', open: false}, this.props.clearFilterMobile);
  }

  handleGroupSelection = value => {
    this.setState({groups: value});
  }

  handleOnApply = () => {
    this.props.setGroups(this.state.groups);
    this.props.setHealthStatus(this.state.status);
    this.props.setCardView(this.state.cardView);
    this.setState({open: false});
  }

  handleCardView = value => {
    this.setState({cardView: value});
  }

  render() {
    const {classes} = this.props;
    return (
      <div>
        <div>
          <IconButton onClick={this.handleOpen} id="filterIcon">
            <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow">
              <Icon color="inherit">filter_list</Icon>
            </Badge>
          </IconButton>
        </div>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleRequestClose}
          className="libraryfilter"
        >
          <AppBar className={classes.appBar} color="default">
            <Toolbar>
              <Typography type="title" color="inherit" className={classes.flex} />
              <Button variant="contained" onClick={this.handleOnClear} id="filterClear" className="btn btn-secondary">
                {I18n.t('action.clear')}
              </Button>
              <Button variant="contained" color="primary" className="btn btn-primary" onClick={this.handleOnApply} id="filterApply">
                {I18n.t('action.apply')}
              </Button>
            </Toolbar>
          </AppBar>
          <List className="librarylist">
            <ListItem id="filterTerminal">
              <MainFilter search={this.props.predict} />
            </ListItem>
            <ListItem>
              <MultipleSelectFilter
                options={this.props.groups.entries}
                label={I18n.t('filter.group.label')}
                value={this.state.groups}
                onChange={this.handleGroupSelection}
                isMobile={false}
                id="filterGroup"
              />
            </ListItem>
            <ListItem>
              <Select
                name="healthStatus"
                options={this.props.status.entries}
                label={I18n.t('filter.healthStatus.label')}
                translationPrefix="filter.healthStatus.option"
                value={this.state.status}
                onChange={this.handleHealthStatusSelection}
                id="filterHealth"
              />
            </ListItem>
            {/* <ListItem>
              <Select
                label={I18n.t('page.dvrHealth.cardType.label')}
                name="cardView"
                onChange={this.handleCardView}
                value={this.state.cardView}
                options={[
                  {id: 'standard', label: I18n.t('page.dvrHealth.cardType.standard')},
                  {id: 'small', label: I18n.t('page.dvrHealth.cardType.small')}
                ]}
              />
            </ListItem> */}
          </List>
        </Dialog>
      </div>
    );
  }
}

const styled = withStyles(styleSheet, {name: 'HealthMobileFilterBar'})(HealthMobileFilterBar);
const mapStateToProps = state => ({...state.i18n.locale, ...state.dvrFilter});
export default connect(mapStateToProps, {
  setCardView,
  setGroups,
  loadGroups,
  loadHealthStatus,
  clearFilterMobile,
  setHealthStatus,
  getReportURL
})(styled);
